import { RetailerHomepage } from '@/features/shop/components/RetailerHomepage'
import { RouteName } from '@shared/constants/routes'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { withHeaderLayout } from '@/features/shared/components/Headers/Layouts/HeaderLayout'
import { inferZipAndStoreForSlugifiedRoute } from '@/features/shared/serverUtils/inferZipAndStoreForSlugifiedRoute'
import { getIsBot } from '@/features/shared/serverUtils/getIsBot'
import { prefetchCatNavCMSForBotSSR } from '@/features/cms/services/CMS/serverUtils'

export const getServerSideProps = createServerSidePropsHandler(
  RouteName.RETAILER_HOMEPAGE,
  async (pageParams) => {
    const result = await inferZipAndStoreForSlugifiedRoute(pageParams)
    // Bail out early on a redirect so we don't warm a cache for a page the
    // crawler will never render.
    if ('redirect' in result) return result

    // Prefetch the category-nav CMS query for bots so the retailer categories
    // render into the SSR HTML by `BotReadableCategoryNav`.
    if (getIsBot(pageParams.ssrContext.req.headers)) {
      await prefetchCatNavCMSForBotSSR(pageParams)
    }

    return result
  },
)

export default withHeaderLayout(RetailerHomepage, {
  showActivityPunchCardButton: true,
})
